import { IContract } from "@axvdex/utils/interfaces";
import { fetchWrapper } from "api";

export const getListOfContracts = (): Promise<{ data?: Array<IContract>; ok: boolean }> => {
  return fetchWrapper("/contract");
};
